<template>
  <div class="ChooseUs flex-box">
    <div class="ChooseUs-title">众多行业客户选择璞华</div>
    <div class="ChooseUs-description">化工材料、食品、饮料、日化、美妆等流程行业、以及其他行业的部分标杆客户</div>
    <div
      style="width: 100%;"
      :class="{'tab-container': !scrollNum}" 
      @mouseenter="clearTimeoutOne"
      @mouseleave="timeoutModuleOne"
    >
      <template v-if="nameVals.length">
        <div class="carousel-box" v-if="scrollNum">
          <div class="carousel-row" :class="{'pl-56': index % 2 !== 1, 'pr-56': index % 2 === 1}" v-for="index in scrollNum" :key="'row' + index">
            <div
              class="carousel-item inline-flex-box"
              v-for="(col, sk) in   (Math.ceil(specificInfo.contentList.length / scrollNum))"
              :key="sk"
              :index="'col' + sk">
              <img v-lazy="getImgAddress(index, col)" alt="">
            </div>
          </div>
        </div>

        <div class="brand-set" v-else>
          <div class="content-box" v-if="specificInfo.contentList">
            <div
              v-for="(subItem, sk) in specificInfo.contentList" 
              :key="sk"
              class="features"
            >
              <img v-lazy="subItem" alt="">
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <mobile-tab-fold :tabs="tabList" :value="activeName" @input="onFoldTab" />
        <el-tabs v-model="activeName" @tab-click="tabsChange">
          <el-tab-pane :label="item.label" :name="item.name" v-for="(item, k) in tabList" :key="k">
            <div class="content-box">
              <div
                v-for="(subItem, sk) in item.contentList" 
                :key="k + sk"
                class="features"
              >
                <img v-lazy="subItem" alt="">
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </template>
    </div>
  </div>
</template>

<script>
import dz1 from '@/assets/images/companyLogo/dz1.png'
import dz2 from '@/assets/images/companyLogo/dz2.png'
import dz3 from '@/assets/images/companyLogo/dz3.png'
import dz4 from '@/assets/images/companyLogo/dz4.png'
import dz5 from '@/assets/images/companyLogo/dz5.png'
import dz6 from '@/assets/images/companyLogo/dz6.png'
import dz7 from '@/assets/images/companyLogo/dz7.png'
import dz8 from '@/assets/images/companyLogo/dz8.png'
import dz9 from '@/assets/images/companyLogo/dz9.png'
import dz10 from '@/assets/images/companyLogo/dz10.png'
import dz11 from '@/assets/images/companyLogo/dz11.png'
import dz12 from '@/assets/images/companyLogo/dz12.png'
import dz13 from '@/assets/images/companyLogo/dz13.png'
import dz14 from '@/assets/images/companyLogo/dz14.png'
import dz15 from '@/assets/images/companyLogo/dz15.png'
import dz16 from '@/assets/images/companyLogo/dz16.png'
import dz17 from '@/assets/images/companyLogo/dz17.png'
import dz18 from '@/assets/images/companyLogo/dz18.png'
import dz19 from '@/assets/images/companyLogo/dz19.png'
import dz20 from '@/assets/images/companyLogo/dz20.jpg'
import dz21 from '@/assets/images/companyLogo/dz21.png'
import dz22 from '@/assets/images/companyLogo/dz22.png'


import hg1 from '@/assets/images/companyLogo/hg1.png'
import hg2 from '@/assets/images/companyLogo/hg2.png'
import hg3 from '@/assets/images/companyLogo/hg3.png'
import hg4 from '@/assets/images/companyLogo/hg4.png'
import hg5 from '@/assets/images/companyLogo/hg5.png'
import hg6 from '@/assets/images/companyLogo/hg6.png'
import hg7 from '@/assets/images/companyLogo/hg7.png'
import hg8 from '@/assets/images/companyLogo/hg8.jpg'
import hg9 from '@/assets/images/companyLogo/hg9.jpg'
import hg10 from '@/assets/images/companyLogo/hg10.jpg'
import hg11 from '@/assets/images/companyLogo/hg11.jpg'
import hg12 from '@/assets/images/companyLogo/hg12.jpg'
import hg13 from '@/assets/images/companyLogo/hg13.jpg'
import hg14 from '@/assets/images/companyLogo/hg14.png'
import hg15 from '@/assets/images/companyLogo/hg15.png'
import hg16 from '@/assets/images/companyLogo/hg16.png'
import hg17 from '@/assets/images/companyLogo/hg17.png'
import hg18 from '@/assets/images/companyLogo/hg18.png'
import hg19 from '@/assets/images/companyLogo/hg19.png'
import hg20 from '@/assets/images/companyLogo/hg20.png'
import hg21 from '@/assets/images/companyLogo/hg21.png'
import hg22 from '@/assets/images/companyLogo/hg22.png'
import hg23 from '@/assets/images/companyLogo/hg23.png'

import sm1 from '@/assets/images/companyLogo/sm1.png'
import sm2 from '@/assets/images/companyLogo/sm2.png'
import sm3 from '@/assets/images/companyLogo/sm3.png'
import sm4 from '@/assets/images/companyLogo/sm4.png'
import sm5 from '@/assets/images/companyLogo/sm5.png'
import sm6 from '@/assets/images/companyLogo/sm6.png'
import sm7 from '@/assets/images/companyLogo/sm7.png'
import sm8 from '@/assets/images/companyLogo/sm8.png'
import sm9 from '@/assets/images/companyLogo/sm9.png'
import sm10 from '@/assets/images/companyLogo/sm10.png'
import sm11 from '@/assets/images/companyLogo/sm11.png'
import sm12 from '@/assets/images/companyLogo/sm12.png'
import sm13 from '@/assets/images/companyLogo/sm13.png'
import sm14 from '@/assets/images/companyLogo/sm14.jpg'
import sm15 from '@/assets/images/companyLogo/sm15.jpg'
import sm16 from '@/assets/images/companyLogo/sm16.jpg'
import sm17 from '@/assets/images/companyLogo/sm17.png'
import sm18 from '@/assets/images/companyLogo/sm18.png'
import sm19 from '@/assets/images/companyLogo/sm19.png'
import sm20 from '@/assets/images/companyLogo/sm20.png'


import xp1 from '@/assets/images/companyLogo/xp1.png'
import xp2 from '@/assets/images/companyLogo/xp2.png'
import xp3 from '@/assets/images/companyLogo/xp3.png'
import xp4 from '@/assets/images/companyLogo/xp4.png'
import xp5 from '@/assets/images/companyLogo/xp5.jpg'
import xp6 from '@/assets/images/companyLogo/xp6.png'
import xp7 from '@/assets/images/companyLogo/xp7.jpg'
import xp8 from '@/assets/images/companyLogo/xp8.jpg'
import xp9 from '@/assets/images/companyLogo/xp9.png'

import zb1 from '@/assets/images/companyLogo/zb1.png'
import zb2 from '@/assets/images/companyLogo/zb2.png'
import zb3 from '@/assets/images/companyLogo/zb3.png'
import zb4 from '@/assets/images/companyLogo/zb4.png'
import zb5 from '@/assets/images/companyLogo/zb5.png'
import zb6 from '@/assets/images/companyLogo/zb6.png'
import zb7 from '@/assets/images/companyLogo/zb7.png'
import zb8 from '@/assets/images/companyLogo/zb8.png'

import zy1 from '@/assets/images/companyLogo/zy1.png'
import zy2 from '@/assets/images/companyLogo/zy2.png'
import zy3 from '@/assets/images/companyLogo/zy3.png'
import zy4 from '@/assets/images/companyLogo/zy4.png'
import zy5 from '@/assets/images/companyLogo/zy5.png'
import zy6 from '@/assets/images/companyLogo/zy6.png'
import zy7 from '@/assets/images/companyLogo/zy7.png'
import zy8 from '@/assets/images/companyLogo/zy8.png'
import zy9 from '@/assets/images/companyLogo/zy9.jpg'

import xn1 from '@/assets/images/companyLogo/xn1.png'

import qt1 from '@/assets/images/companyLogo/qt1.png'
import qt2 from '@/assets/images/companyLogo/qt2.png'
import qt3 from '@/assets/images/companyLogo/qt3.png'
import qt4 from '@/assets/images/companyLogo/qt4.png'

import sp1 from '@/assets/images/companyLogo/sp1.png'
import sp2 from '@/assets/images/companyLogo/sp2.png'
import sp3 from '@/assets/images/companyLogo/sp3.png'
import sp4 from '@/assets/images/companyLogo/sp4.png'
import sp5 from '@/assets/images/companyLogo/sp5.png'
import sp6 from '@/assets/images/companyLogo/sp6.png'
import sp7 from '@/assets/images/companyLogo/sp7.jpg'
import sp8 from '@/assets/images/companyLogo/sp8.png'
import sp9 from '@/assets/images/companyLogo/sp9.png'

import ny1 from '@/assets/images/companyLogo/ny1.png'
import ny2 from '@/assets/images/companyLogo/ny2.png'

import rh1 from '@/assets/images/companyLogo/rh1.png'


import dzkj1 from '@/assets/images/companyLogo/dzkj1.png'
import dzkj2 from '@/assets/images/companyLogo/dzkj2.png'

import hgcl1 from '@/assets/images/companyLogo/hgcl1.png'
import hgcl2 from '@/assets/images/companyLogo/hgcl2.png'
import hgcl3 from '@/assets/images/companyLogo/hgcl3.png'
import hgcl4 from '@/assets/images/companyLogo/hgcl4.jpg'
import hgcl5 from '@/assets/images/companyLogo/hgcl5.png'
import hgcl6 from '@/assets/images/companyLogo/hgcl6.png'
import hgcl7 from '@/assets/images/companyLogo/hgcl7.jpg'
import hgcl8 from '@/assets/images/companyLogo/hgcl8.png'
import hgcl9 from '@/assets/images/companyLogo/hgcl9.png'
import hgcl10 from '@/assets/images/companyLogo/hgcl10.png'
import hgcl11 from '@/assets/images/companyLogo/hgcl11.png'
import hgcl12 from '@/assets/images/companyLogo/hgcl12.png'
import hgcl13 from '@/assets/images/companyLogo/hgcl13.png'

import sp11 from '@/assets/images/companyLogo/sp11.jpg'
import sp12 from '@/assets/images/companyLogo/sp12.png'
import sp13 from '@/assets/images/companyLogo/sp13.jpg'
import sp14 from '@/assets/images/companyLogo/sp14.png'
import sp15 from '@/assets/images/companyLogo/sp15.png'
import sp16 from '@/assets/images/companyLogo/sp16.png'
import sp17 from '@/assets/images/companyLogo/sp17.png'

import rhmz1 from '@/assets/images/companyLogo/rhmz1.png'
import rhmz2 from '@/assets/images/companyLogo/rhmz2.jpg'
import rhmz3 from '@/assets/images/companyLogo/rhmz3.png'
import rhmz4 from '@/assets/images/companyLogo/rhmz4.jpg'

import zy11 from '@/assets/images/companyLogo/zy11.jpg'

import yljx1 from '@/assets/images/companyLogo/yljx1.png'
import yljx2 from '@/assets/images/companyLogo/yljx2.png'
import yljx3 from '@/assets/images/companyLogo/yljx3.png'
import yljx4 from '@/assets/images/companyLogo/yljx4.png'
import MobileTabFold from '@/components/MobileTabFold/index.vue'

export default {
  components: { MobileTabFold },
  props: {
    nameVals: {
      type: Array,
      default: () => {
        return []
      }
    },
    scrollNum: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      activeName: 'ChemicalIndustry',
      otherObj: {
        OracleAgile: [xn1,qt4,hg5],
      },
      allTabList: [
        {
          name: 'ChemicalIndustry',
          label: '化工材料',
          contentList: [hg1,hg2,hg3,hg4,hg7,hg6,hg8,hg9,hg11,hg16,hg17,hg18,hg19,hg21,hg22,hg23, hgcl1, hgcl2, hgcl3, hgcl4, hgcl5, hgcl6, hgcl7, hgcl8, hgcl9, hgcl10, hgcl11, hgcl12, hgcl13, ny1, ny2]
        },
        {
          name: 'Food',
          label: '食品',
          contentList: [sp1,sp2,sp8,sp9,sp11,sp12,sp13,sp14,sp15,sp16]
        },
        {
          name: 'WearMakeup',
          label: '日化美妆',
          contentList: [hg14,hg20,rh1,rhmz1,rhmz2,rhmz3,rhmz4]
        },
        {
          name: 'Pharmaceutical',
          label: '制药',
          contentList: [zy8,zy9,zy11]
        },
        {
          name: 'semiconductor',
          label: '芯片半导体',
          contentList: [xp1,xp2,xp3,xp4,xp5,xp9]
        },
        {
          name: 'electron',
          label: '电子高科技',
          contentList: [dz1,dz2,dz4,dz5,dz6,dz7,dz8,dz9,dz10,dz11,dz13,dz14,dz15,dz16,dz17,dz18,dz19,dz20,dz21,dz22,dzkj1,dzkj2]
        },
        {
          name: 'MedicalEquipment',
          label: '医疗器械',
          contentList: [sm1,sm2,sm3,sm4,sm5,sm6,sm8,sm9,sm10,sm12,sm13,sm15,sm16,sm17,sm18,sm19,sm20,yljx1,yljx3,yljx4]
        },
        {
          name: 'EquipmentManufacturing',
          label: '机械制造',
          contentList: [zb1,zb2,zb3,zb4,zb5,zb6,zb7,zb8]
        }
      ],
      
      activeIndexOne: 2,
      timeoutOne: null,
      
    }
  },
  watch: {
    activeName: {
      handler(n) {
      }
    }
  },
  computed: {
    tabList({ allTabList }) {
      const hideOnHome = ['EquipmentManufacturing', 'Pharmaceutical', 'MedicalEquipment']
      const list = allTabList.filter(item => !hideOnHome.includes(item.name))
      const pharma = allTabList.find(item => item.name === 'Pharmaceutical')
      const medical = allTabList.find(item => item.name === 'MedicalEquipment')
      const lifeScience = {
        name: 'LifeScience',
        label: '生命科学',
        contentList: [
          ...(pharma ? pharma.contentList : []),
          ...(medical ? medical.contentList : [])
        ]
      }
      const wearIdx = list.findIndex(item => item.name === 'WearMakeup')
      if (wearIdx >= 0) list.splice(wearIdx + 1, 0, lifeScience)
      else list.push(lifeScience)
      return list
    },
    specificInfo({ nameVals, allTabList, otherObj }) {
      let contentList = []
      allTabList.forEach(item => {
        if(nameVals.includes(item.name)) {
          contentList.push(...item.contentList)
        }
      });
      nameVals.forEach(item => {
        if(otherObj[item]) contentList.push(...otherObj[item])
      })
      return { contentList }
    }
  },
  mounted() {
    this.timeoutModuleOne();
  },
  destroyed() {
    this.clearTimeoutOne();
  },
  methods: {
    getImgAddress(index, col) {
      const num = Math.ceil(this.specificInfo.contentList.length / this.scrollNum)
      const imgIndex = col % num ? col % num : num;
      let imgInd = (index - 1) * num + imgIndex;
      imgInd = imgInd > this.specificInfo.contentList.length ? imgInd - this.specificInfo.contentList.length : imgInd
      return this.specificInfo.contentList[imgInd - 1]
    },
    timeoutModuleOne() {
      if(this.nameVals.length) return
      this.timeoutOne = setInterval(() => {
        if (this.activeIndexOne === this.tabList.length -1) {
          this.activeIndexOne = 0;
        } else {
          this.activeIndexOne++;
        }
        this.activeName = this.tabList[this.activeIndexOne].name
      }, 3000)
    },
    clearTimeoutOne() {
      clearInterval(this.timeoutOne)
    },
    tabsChange(val, aaa) {
      this.activeIndexOne = Number(val.index);
    },
    onFoldTab(name) {
      this.activeName = name
      const idx = this.tabList.findIndex(item => item.name === name)
      if (idx >= 0) this.activeIndexOne = idx
    }
  }
}
</script>

<style lang="scss" scoped>
$img: "../../assets/images";
@keyframes scroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(calc(-100% + 100vw - 20rem));
  }
}

.ChooseUs {
  flex-direction: column;
  align-items: center;

  .ChooseUs-title {
    font-size: 4rem;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333;
    line-height: 4rem;
    padding: 9rem 0 2.4rem;
  }

  .ChooseUs-description {
    font-size: 1.8rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666A77;
    line-height: 1.8rem;
    padding-bottom: 7.6rem;
  }
  .carousel-box {
      width: max-content;
      animation: scroll 20s linear infinite;
      
      &:hover {
        animation: scroll 20s linear infinite paused;
      }
      
      .carousel-row {
        width: max-content;

        .carousel-item {
          width: 30rem;
          height: 12rem;
          padding: 2rem 3rem;
          margin: 0 3rem 3rem 0;
          box-shadow: 0 0.8rem 1.5rem 0 rgba(0,0,0,0.1);
          align-items: center;
          justify-content: center;
          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
            object-position: center;
          }
        }
      }

      .pl-56 {
        padding-left: 5.6rem;
      }
      .pr-56 {
        padding-right: 5.6rem;
      }
    }

  .tab-container {
    display: flex;
    justify-content: center;

    ::v-deep .el-tabs {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;

      .el-tabs__nav-wrap::after {
        display: none;
      }
      .el-tabs__header {
        width: calc(192rem - 52rem);
        margin: 0;
        .el-tabs__nav {
          width: 100%;
          display: flex;
          .el-tabs__item {
            flex: 1;
            height: 4.6rem;
            display: inline-flex;
            justify-content: center;
            font-size: 2rem;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            line-height: 2rem;
            box-shadow: none;
          }

          .el-tabs__active-bar {
            height: 0.2rem;
            width: 33%;
            background-color: #FB0000;
          }

          .el-tabs__item.is-active, .el-tabs__item:hover {
            color: #FB0000;
          }
        }
      }
      .el-tabs__content {
        width: 100%;
        background-color: #F8F9FB;
      }
    }

  }

  .brand-set {
    width: 100%;
    background-color: #F8F9FB;
  }

  .content-box {
    position: relative;
    width: calc(192rem - 52rem);
    margin: 6rem auto 8rem;
    overflow: hidden;
    .features {
      float: left;
      width: 30rem;
      height: 12rem;
      background: #FFFFFF;
      box-shadow: 0rem 0.8rem 1.5rem 0rem rgba(0,0,0,0.1);
      margin: 0 0 3.2rem 4rem;
      padding: 2rem 3rem;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        object-position: center;
      }
    }
  }
}

@import "@/styles/mixins.scss";

@include mobile {
  .ChooseUs {
    .ChooseUs-title {
      font-size: 2.4rem;
      line-height: 3.2rem;
      padding: 4.8rem 1.6rem 1.6rem;
      text-align: center;
    }
    .ChooseUs-description {
      font-size: 1.4rem;
      line-height: 2.2rem;
      padding: 0 1.6rem 3.2rem;
      text-align: center;
    }
    .carousel-item {
      width: 15.6rem;
      height: 8.8rem;
      padding: 1.2rem 1.4rem;
      margin: 0 1.2rem 1.2rem 0;
    }
    .pl-56 {
      padding-left: 2.4rem;
    }
    .pr-56 {
      padding-right: 2.4rem;
    }
    ::v-deep .el-tabs__header {
      display: none !important;
    }
    .content-box {
      width: 100%;
      margin: 2.4rem auto 4rem;
      padding: 0 1.6rem;
      overflow: visible;
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 1.2rem;
      .features {
        float: none;
        width: 100%;
        height: 8.8rem;
        margin: 0;
        padding: 1.2rem 1.4rem;
      }
    }
  }
}
</style>
